import { render, staticRenderFns } from "./ReportsView.vue?vue&type=template&id=f671d882&scoped=true"
import script from "./ReportsView.vue?vue&type=script&lang=js"
export * from "./ReportsView.vue?vue&type=script&lang=js"
import style0 from "./ReportsView.vue?vue&type=style&index=0&id=f671d882&prod&lang=scss&scoped=true"
import style1 from "./ReportsView.vue?vue&type=style&index=1&id=f671d882&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f671d882",
  null
  
)

export default component.exports